module.exports = "/_next/static/images/basketballWhiteIcon@3x-d6f3d3de59b0bef33931111613cf30e8.png";